<template>
	<div>
		<page-title :name="pageName" :title="pageTitle" :breadcrumbs="pageBreadcrumbs" />

		<div v-if="landing" class="landings-page padding-top-20 padding-bottom-20">
			<div class="container">
				<div>
					<h3 class="landing-title">
						{{ landing.title }}
					</h3>
					<vue-markdown v-if="landing.text_top" class="landing-text">{{ landing.text_top }}</vue-markdown>
				</div>

				<div v-if="landing.cta_top_title" class="margin-bottom-50 margin-top-30 text-center">
					<div class="container">
						<h3>{{ landing.cta_top_title }}</h3>
						<a
							v-if="landing.cta_top_link && landing.cta_top_value"
							:href="landing.cta_top_link"
							class="button button-5 margin-top-20"
						>
							{{ landing.cta_top_value }}
						</a>
					</div>
				</div>

				<div v-html="$t('Page.Content.LandingsDetailBlock1')"></div>
			</div>
		</div>

		<div class="padding-bottom-50">
			<div class="container">
				<div class="page-content text">
					<div v-html="$t('Page.Content.LandingsDetailBlock2')"></div>
				</div>
				<div v-if="landing" class="page-content">
					<div v-if="landing.cta_bottom_title" class="margin-bottom-50 margin-top-30 text-center">
						<div class="container">
							<h3>{{ landing.cta_bottom_title }}</h3>
							<a
								v-if="landing.cta_bottom_link && landing.cta_bottom_value"
								:href="landing.cta_bottom_link"
								class="button button-5 margin-top-20"
							>
								{{ landing.cta_bottom_value }}
							</a>
						</div>
					</div>

					<vue-markdown v-if="landing.text_bottom">{{ landing.text_bottom }}</vue-markdown>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'
import AccountInfo from '@/mixins/AccountInfo'
import PageInfo from '@/mixins/PageInfo'
import PageTitle from '@/components/partials/PageTitle'
import ServiceHelper from '@/mixins/ServiceHelper'

export default {
	name: 'LandingsDetail',
	components: {
		PageTitle,
		VueMarkdown,
	},
	mixins: [AccountInfo, PageInfo, ServiceHelper],
	props: {
		code: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			pageToNotIndexFromRobots: true,
			pageByCode: true,
			landing: null,
		}
	},
	created() {
		// Retrieve landing from API
		this.loadData()
	},
	methods: {
		loadData() {
			// Get data
			axios
				.get('/landings/' + this.code, {
					params: this.loadAllParams,
				})
				.then((response) => {
					this.landing = response.data.info
				})
				.catch((error) => {
					console.log(error)
				})
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/views/core/landings/LandingsDetail.vue